import { pt } from './pt'

export const translations = {
  pt_PT: pt
}



// WEBPACK FOOTER //
// ./src/translations/index.js